// 行政区域管理页面
export const REGION_PAGE_UUID = '5b692d8d-6fc7-42f9-a6bd-f2f453d87601'

// 管理行政区域
export const REGION_ACTION_UUID = '0365660e-aa77-4905-84e5-24099b57f259'
